import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=ea480e9c&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "./Header.vue?vue&type=style&index=0&id=ea480e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea480e9c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/opt/build/repo/components/storyblok/Header.vue').default,BannerAlert: require('/opt/build/repo/components/storyblok/BannerAlert.vue').default})
